import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Ticket, SignOut, UserCircle, GridFour, QrCode } from "@phosphor-icons/react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="w-8 h-8 bg-primary flex items-center justify-center neon-glow">
            <Ticket weight="fill" size={20} className="text-black" />
          </div>
          <span className="font-heading font-black text-xl tracking-tighter text-white">
            EVENT<span className="text-primary">KU</span>
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          <Link to="/" data-testid="nav-events" className="hidden sm:block text-sm font-semibold text-zinc-300 hover:text-primary transition-colors px-3">
            Acara
          </Link>
          {user && (
            <Link to="/tickets" data-testid="nav-my-tickets" className="text-sm font-semibold text-zinc-300 hover:text-primary transition-colors px-3">
              Tiket Saya
            </Link>
          )}
          {user && (
            <Link to="/orders" data-testid="nav-orders" className="hidden sm:block text-sm font-semibold text-zinc-300 hover:text-primary transition-colors px-3">
              Pesanan
            </Link>
          )}
          {user && ["admin", "scanner"].includes(user.role) && (
            <Link to="/scan" data-testid="nav-scanner">
              <Button variant="outline" size="sm" className="border-primary/50 text-primary hover:bg-primary hover:text-black rounded-none gap-1.5">
                <QrCode size={16} weight="bold" /> Scan
              </Button>
            </Link>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin">
              <Button variant="outline" size="sm" className="border-white/20 text-white hover:bg-white hover:text-black rounded-none gap-1.5">
                <GridFour size={16} weight="bold" /> Admin
              </Button>
            </Link>
          )}
          {user ? (
            <div className="flex items-center gap-2">
              <span className="hidden md:flex items-center gap-1.5 text-sm text-zinc-400">
                <UserCircle size={18} weight="fill" className="text-primary" /> {user.name?.split(" ")[0]}
              </span>
              <Button
                data-testid="logout-btn"
                variant="ghost" size="sm"
                onClick={() => { logout(); navigate("/"); }}
                className="text-zinc-400 hover:text-secondary rounded-none"
              >
                <SignOut size={18} weight="bold" />
              </Button>
            </div>
          ) : (
            <Link to="/login" data-testid="nav-login">
              <Button size="sm" className="bg-primary text-black font-bold hover:bg-cyan-300 rounded-none">
                Masuk
              </Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
